import { type IIcon } from '@/app/types/iconType'

export const Minus = (props: Omit<IIcon, 'iconName'>) => {
    const { height = '20', width = '20', color = '#fff' } = props
    return (
        <svg width={width} height={height} viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M6.5 9H14.5C15.0523 9 15.5 9.44771 15.5 10C15.5 10.5523 15.0523 11 14.5 11H6.5C5.94772 11 5.5 10.5523 5.5 10C5.5 9.44771 5.94772 9 6.5 9Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0.5 5C0.5 2.23858 2.73858 0 5.5 0H15.5C18.2614 0 20.5 2.23858 20.5 5V15C20.5 17.7614 18.2614 20 15.5 20H5.5C2.73858 20 0.5 17.7614 0.5 15V5ZM2.5 5C2.5 3.34315 3.84315 2 5.5 2H15.5C17.1569 2 18.5 3.34315 18.5 5V15C18.5 16.6569 17.1569 18 15.5 18H5.5C3.84315 18 2.5 16.6569 2.5 15V5Z'
                fill={color}
            />
        </svg>
    )
}
